import { createI18n } from 'vue-i18n';


export const language: any = {
  'en': require('@/i18n/locales/en-US.json'),
  'zh': require('@/i18n/locales/zh-CN.json'),
  'zh-tw': require('@/i18n/locales/zh-TW.json'),
  'id': require('@/i18n/locales/id-ID.json'),
  'th': require('@/i18n/locales/th.json'),
  'ko': require('@/i18n/locales/ko.json'),
  'ja': require('@/i18n/locales/ja.json'),
};


/**
 * 检测浏览器语言并映射到支持的语言
 * @returns 支持的语言代码 'en' | 'zh' | 'zh-tw'
 */
const detectBrowserLanguage = (): string => {
  // 获取浏览器语言
  const browserLang = navigator.language || (navigator as any).userLanguage || 'en';
  const lang = browserLang.toLowerCase();
  console.log(lang);

  // 简体 / 繁体中文
  if (lang.startsWith('zh')) {
    if (lang.includes('tw') || lang.includes('hk') || lang.includes('mo') || lang.includes('hant')) {
      return 'zh-tw';
    }
    return 'zh';
  }
  // 印尼语 id / id-id
  if (lang.startsWith('id')) {
    return 'id';
  }
  // 日语 ja / ja-jp
  if (lang.startsWith('ja')) {
    return 'ja';
  }
  // 韩语 ko / ko-kr
  if (lang.startsWith('ko')) {
    return 'ko';
  }
  // 泰语 th / th-th
  if (lang.startsWith('th')) {
    return 'th';
  }
  // 默认英文
  return 'en';
};


export const defaultLang = detectBrowserLanguage()


// 从 localStorage 获取保存的语言
const savedLocale = localStorage.getItem('locale');

// 如果有保存的语言且支持，使用保存的语言；否则检测浏览器语言
let initialLocale: string;
if (savedLocale && language[savedLocale]) {
  initialLocale = savedLocale;
} else {
  // 自动检测浏览器语言
  initialLocale = detectBrowserLanguage();
  // 将检测到的语言保存到 localStorage，避免每次刷新都重新检测
  localStorage.setItem('locale', initialLocale);
}

const i18n = createI18n({
  legacy: false,              // 使用 composition API 的 useI18n
  globalInjection: true,   // 可在模板内直接使用 $t
  locale: initialLocale,
  fallbackLocale: defaultLang,
  messages: language
})

export default i18n
